function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var detail = {
    detail: data
  };
  var event = new CustomEvent(eventName, data ? detail : null);
  document.dispatchEvent(event);
};

/**
 *  @class
 *  @function Quantity
 */
if (!customElements.get('quantity-selector')) {
  class QuantityInput extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('.qty');
      this.step = parseInt(this.input.getAttribute('step'));
      this.changeEvent = new Event('change', {
        bubbles: true
      });
      // Create buttons
      this.subtract = this.querySelector('.minus');
      this.add = this.querySelector('.plus');
    }
    initEvents() {
      const that = this;
      this.subtract.addEventListener('click', (e) => {
        e.preventDefault();
        that.change_quantity(-1 * that.step);
      });
      this.add.addEventListener('click', (e) => {
        e.preventDefault();
        that.change_quantity(1 * that.step);
      });
      this.classList.add('buttons_added');
    }
    connectedCallback() {
      this.initEvents();
    }
    change_quantity(change) {
      // Get current value
      let quantity = parseInt(this.input.value);
      // Ensure quantity is a valid number
      if (isNaN(quantity)) quantity = 1;

      const min = parseInt(this.input.getAttribute('min')) || 1;
      const max = parseInt(this.input.getAttribute('max'));
      // Check for min & max
      if (min > (quantity + change)) {
        return;
      }
      if (max && max < (quantity + change)) {
        return;
      }
      // Change quantity
      quantity += change;

      // Ensure quantity is always a number
      quantity = Math.max(quantity, 1);

      // Output number
      this.input.value = quantity;

      this.input.dispatchEvent(this.changeEvent);
    }
  }
  customElements.define('quantity-selector', QuantityInput);
}

/**
 *  @class
 *  @function ArrowSubMenu
 */
class ArrowSubMenu {

  constructor(self) {
    this.submenu = self.parentNode.querySelector('.sub-menu');
    this.arrow = self;
    // Add functionality to buttons
    self.addEventListener('click', (e) => this.toggle_submenu(e));
  }

  toggle_submenu(e) {
    e.preventDefault();
    let submenu = this.submenu;

    if (!submenu.classList.contains('active')) {
      submenu.classList.add('active');

    } else {
      submenu.classList.remove('active');
      this.arrow.blur();
    }
  }
}
let arrows = document.querySelectorAll('.thb-arrow');
arrows.forEach((arrow) => {
  new ArrowSubMenu(arrow);
});

/**
 *  @class
 *  @function ProductCard
 */
if (!customElements.get('product-card')) {
  class ProductCard extends HTMLElement {
    constructor() {
      super();
      this.swatches = this.querySelector('.product-card-swatches');
      this.image = this.querySelector('.product-featured-image-link .product-primary-image');
      this.secondary = this.querySelector('.product-featured-image-link .product-secondary-image');
      this.quick_add = this.querySelector('.product-card--add-to-cart-button-simple');
    }

    connectedCallback() {
      this.normalizeProductCardUrls();
      if (this.swatches) {
        this.enableSwatches();
      }
      if (this.quick_add) {
        this.enableQuickView();
      }
      if (this.secondary) {
        window.addEventListener('load', () => {
          lazySizes.loader.unveil(this.secondary);
        });
      }
    }

    isAlgoliaInstantSearchCard() {
      return this.getAttribute('data-source-file') === 'algolia-instant-search';
    }

    isRecommendationCard() {
      return !!this.closest('product-recommendations');
    }

    supportsInteractiveSwatches() {
      return this.isAlgoliaInstantSearchCard() || this.isRecommendationCard();
    }

    canonicalProductUrl(url) {
      if (!url) {
        return '';
      }

      const rawUrl = String(url);

      try {
        const parsed = new URL(rawUrl, window.location.origin);
        if (!parsed.pathname.includes('/products/')) {
          return rawUrl;
        }
        parsed.searchParams.delete('variant');
        return `${parsed.pathname}${parsed.search}${parsed.hash}`;
      } catch (error) {
        if (!rawUrl.includes('/products/')) {
          return rawUrl;
        }
        return rawUrl
          .replace(/([?&])variant=[^&#]*&?/i, '$1')
          .replace(/\?&/, '?')
          .replace(/[?&]$/, '');
      }
    }

    normalizeProductCardUrls() {
      this.querySelectorAll('a.product-featured-image-link, a.product-card-title').forEach((link) => {
        const href = link.getAttribute('href');
        if (href) {
          link.setAttribute('href', this.canonicalProductUrl(href));
        }
      });

      this.querySelectorAll('.product-card-swatch[data-href]').forEach((swatch) => {
        const href = swatch.getAttribute('data-href');
        if (href) {
          swatch.setAttribute('data-href', this.canonicalProductUrl(href));
        }
      });
    }

    prepareSwatchState() {
      if (!this.supportsInteractiveSwatches()) {
        return;
      }

      if (!this.dataset.defaultPriceCaptured) {
        const priceAmount = this.querySelector('.price ins .amount, .price .amount');
        const compareAmount = this.querySelector('.price del .amount');
        if (priceAmount) {
          this.dataset.defaultPriceLabel = priceAmount.textContent.trim();
        }
        if (compareAmount) {
          this.dataset.defaultCompareLabel = compareAmount.textContent.trim();
        }
        this.dataset.defaultPriceCaptured = '1';
      }

      if (this.isAlgoliaInstantSearchCard()) {
        if (this.dataset.algoliaRenderToken !== this.getAttribute('data-algolia-objectid')) {
          this.dataset.algoliaRenderToken = this.getAttribute('data-algolia-objectid') || '';
          delete this.dataset.selectedSwatchHref;
        }
      }
    }

    bindSwatchMoreButton() {
      if (!this.supportsInteractiveSwatches() || !this.swatches) {
        return;
      }

      const moreButton = this.swatches.querySelector('.product-card-swatch-more');
      if (!moreButton || moreButton.dataset.swatchMoreBound === 'true') {
        return;
      }

      moreButton.dataset.swatchMoreBound = 'true';
      moreButton.addEventListener('click', (event) => {
        event.preventDefault();
        event.stopPropagation();
        this.swatches.classList.add('is-expanded');
        moreButton.setAttribute('aria-expanded', 'true');
        this.enableSwatches();
      });
    }

    getSwatchPath(url) {
      if (!url) {
        return '';
      }

      try {
        return new URL(url, window.location.origin).pathname;
      } catch (error) {
        return String(url).split('?')[0];
      }
    }

    getSwatchVariantId(url) {
      if (!url) {
        return '';
      }

      const match = String(url).match(/[?&]variant=(\d+)/);
      return match ? match[1] : '';
    }

    formatSwatchPrice(raw) {
      const currencyCode =
        this.dataset.currencyCode ||
        this.querySelector('.price')?.dataset.currencyCode ||
        window.GraphQLUtils?.getMarketCurrencyCode?.();

      if (window.GraphQLUtils?.formatMarketPriceFromRaw) {
        return window.GraphQLUtils.formatMarketPriceFromRaw(raw, currencyCode);
      }

      if (typeof window.teqFormatPriceFromRaw === 'function') {
        return window.teqFormatPriceFromRaw(raw);
      }

      const value = parseFloat(String(raw || '').replace(/[^0-9.-]/g, ''));
      if (!Number.isFinite(value)) {
        return '';
      }

      const symbol =
        window.theme?.settings?.currency_symbol ||
        window.GraphQLUtils?.getMarketCurrencySymbol?.(currencyCode) ||
        '$';

      return `${symbol}${value.toFixed(2)}`.replace(/\.00$/, '');
    }

    normalizeSwatchPriceToCents(raw) {
      if (typeof window.teqNormalizePriceToCents === 'function') {
        return window.teqNormalizePriceToCents(raw);
      }

      const value = parseFloat(String(raw || '').replace(/[^0-9.-]/g, ''));
      return Number.isFinite(value) ? Math.round(value * 100) : null;
    }

    resolveSwatchCompareAt(swatch, rawPrice) {
      const fromSwatch = swatch?.getAttribute('data-compare-at-price') || '';
      const fromCard = this.getAttribute('data-default-compare-at-price') || '';
      const priceCents = this.normalizeSwatchPriceToCents(rawPrice);

      const candidates = [fromSwatch, fromCard].filter(Boolean);

      // Recommendation metafields often omit compare-at; use the highest sibling swatch price.
      if (this.isRecommendationCard() && this.swatches) {
        this.swatches.querySelectorAll('.product-card-swatch[data-href][data-price]').forEach((el) => {
          const siblingPrice = el.getAttribute('data-price') || '';
          const siblingCompare = el.getAttribute('data-compare-at-price') || '';
          if (siblingCompare) {
            candidates.push(siblingCompare);
          }
          if (siblingPrice) {
            candidates.push(siblingPrice);
          }
        });
      }

      for (const candidate of candidates) {
        const compareCents = this.normalizeSwatchPriceToCents(candidate);
        if (
          compareCents != null &&
          priceCents != null &&
          compareCents > priceCents
        ) {
          return candidate;
        }
      }

      return '';
    }

    applySwatchPrice(swatch) {
      if (!this.supportsInteractiveSwatches()) {
        return;
      }

      const priceRoot = this.querySelector('.price');
      if (!priceRoot) {
        return;
      }

      const rawPrice = swatch?.getAttribute('data-price') || '';
      if (!rawPrice) {
        return;
      }

      const rawCompare = this.resolveSwatchCompareAt(swatch, rawPrice);
      const displayPrice = this.formatSwatchPrice(rawPrice);
      if (!displayPrice) {
        return;
      }

      const priceCents = this.normalizeSwatchPriceToCents(rawPrice);
      const compareCents = this.normalizeSwatchPriceToCents(rawCompare);
      const showCompare =
        compareCents != null && priceCents != null && compareCents > priceCents;

      let delEl = priceRoot.querySelector('del');
      let insEl = priceRoot.querySelector('ins');

      if (!insEl) {
        insEl = document.createElement('ins');
        insEl.innerHTML = '<span class="amount"></span>';
        // Keep unit-price / other nodes after the sale amount.
        const unitPrice = priceRoot.querySelector('small.unit-price');
        if (unitPrice) {
          priceRoot.insertBefore(insEl, unitPrice);
        } else {
          priceRoot.appendChild(insEl);
        }
      }

      const amountEl = insEl.querySelector('.amount') || insEl;
      amountEl.textContent = displayPrice;

      if (showCompare) {
        const compareFormatted = this.formatSwatchPrice(rawCompare);
        if (!delEl) {
          delEl = document.createElement('del');
          delEl.innerHTML = '<span class="amount"></span>';
          priceRoot.insertBefore(delEl, insEl);
        }
        const delAmount = delEl.querySelector('.amount') || delEl;
        delAmount.textContent = compareFormatted;
      } else if (delEl) {
        delEl.remove();
      }
    }

    ensureSecondaryImage(altText = '') {
      const imageLink = this.querySelector('.product-featured-image-link');
      const primaryImage = this.querySelector('.product-primary-image');
      if (!imageLink) {
        return null;
      }

      let secondary = this.querySelector('.product-secondary-image');
      if (!secondary) {
        secondary = document.createElement('img');
        secondary.className = 'product-secondary-image lazyload';
        secondary.alt = altText;
        secondary.style.width = '100%';
        secondary.style.height = '100%';
        imageLink.insertBefore(secondary, primaryImage);
      }

      return secondary;
    }

    bindSwatchHoverReset() {
      if (!this.swatches) {
        return;
      }

      const swatchList = this.swatches.querySelectorAll('.product-card-swatch[data-href]');
      if (!swatchList.length) {
        return;
      }

      if (!this._swatchHoverResetHandler) {
        this._swatchHoverResetHandler = () => {
          this.setDefaultActiveSwatch({ preferPersisted: true });
        };
      }

      if (this._swatchHoverResetElement !== this.swatches) {
        if (this._swatchHoverResetElement) {
          this._swatchHoverResetElement.removeEventListener(
            'mouseleave',
            this._swatchHoverResetHandler
          );
        }

        this.swatches.addEventListener('mouseleave', this._swatchHoverResetHandler);
        this._swatchHoverResetElement = this.swatches;
      }
    }

    enableSwatches() {
      this.swatches = this.querySelector('.product-card-swatches');
      if (!this.swatches) {
        return;
      }

      this.normalizeProductCardUrls();
      this.prepareSwatchState();
      this.bindSwatchMoreButton();

      const swatchList = this.swatches.querySelectorAll('.product-card-swatch[data-href]');
      if (!swatchList.length) {
        return;
      }

      swatchList.forEach((swatch) => {
        if (swatch.dataset.swatchBound === 'true') {
          return;
        }
        swatch.dataset.swatchBound = 'true';

        swatch.addEventListener('mouseenter', () => {
          this.applySwatchSelection(swatch, swatchList, { persist: false });
        });

        swatch.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();
          this.applySwatchSelection(swatch, swatchList, { persist: true });
        });
      });
      this.setDefaultActiveSwatch({ preferPersisted: true });
      this.bindSwatchHoverReset();
    }

    applySwatchSelection(swatch, swatchList, { persist = false } = {}) {
      const list = swatchList || this.swatches.querySelectorAll('.product-card-swatch[data-href]');
      list.forEach((el) => el.classList.remove('active'));
      swatch.classList.add('active');

      const primaryImage = this.querySelector('.product-primary-image');
      const secondaryImage = this.supportsInteractiveSwatches()
        ? this.ensureSecondaryImage(primaryImage?.alt || '')
        : this.querySelector('.product-secondary-image');
      const imageLink = this.querySelector('.product-featured-image-link');
      const titleLink = this.querySelector('.product-card-title');
      const figure = this.querySelector('.product-featured-image');
      const urlDataset = this.canonicalProductUrl(swatch.getAttribute('data-href'));
      swatch.setAttribute('data-href', urlDataset);
      let hrefToUse = urlDataset;

      if (
        this.isAlgoliaInstantSearchCard() &&
        window.NatoriAlgoliaPLP?.applyFilteredVariantLinkForSwatch
      ) {
        const filteredUrl = window.NatoriAlgoliaPLP.applyFilteredVariantLinkForSwatch(
          this,
          swatch
        );
        if (filteredUrl) {
          hrefToUse = this.canonicalProductUrl(filteredUrl);
        }
      } else if (this.isAlgoliaInstantSearchCard() && this.dataset.filteredVariantUrl) {
        const cardHandle = this.getAttribute('data-handle') || '';
        const swatchPath = this.getSwatchPath(urlDataset || '');
        if (cardHandle && swatchPath === `/products/${cardHandle}`) {
          hrefToUse = this.canonicalProductUrl(this.dataset.filteredVariantUrl);
        }
      }

      if (persist) {
        this.dataset.selectedSwatchHref = hrefToUse || swatch.getAttribute('data-href') || '';
      }

      const primaryDataset = swatch.getAttribute('data-srcset');
      const secondaryDataset = swatch.getAttribute('data-srcset-2');
      const primaryDatasetAlt = swatch.getAttribute('data-srcset-alt') || '';
      const secondaryDatasetAlt = swatch.getAttribute('data-srcset-2-alt') || '';

      if (hrefToUse) {
        if (imageLink) {
          imageLink.setAttribute('href', hrefToUse);
        }
        if (titleLink) {
          titleLink.setAttribute('href', hrefToUse);
        }
      }

      this.applySwatchPrice(swatch);

      if (primaryImage && primaryDataset) {
        let newPrimarySrcset = primaryDataset || '';
        if (!newPrimarySrcset) {
          newPrimarySrcset = '/cdn/shop/t/1/assets/natoriplaceholder.png';
        }
        const primarySrc = newPrimarySrcset.includes(' ')
          ? newPrimarySrcset.split(',')[0].trim().split(' ')[0]
          : newPrimarySrcset.split(' ')[0];
        primaryImage.setAttribute('srcset', newPrimarySrcset);
        primaryImage.src = primarySrc;
        if (primaryDatasetAlt) {
          primaryImage.alt = primaryDatasetAlt;
        }
        if (this.supportsInteractiveSwatches()) {
          primaryImage.removeAttribute('data-srcset');
        }
        if (window.lazySizes?.loader) {
          window.lazySizes.loader.unveil(primaryImage);
        }
      }

      if (secondaryImage && secondaryDataset) {
        const secondarySrc = secondaryDataset.includes(' ')
          ? secondaryDataset.split(',')[0].trim().split(' ')[0]
          : secondaryDataset.split(' ')[0];
        secondaryImage.setAttribute('srcset', secondaryDataset);
        secondaryImage.src = secondarySrc;
        if (secondaryDatasetAlt) {
          secondaryImage.alt = secondaryDatasetAlt;
        }
        secondaryImage.removeAttribute('hidden');
        figure?.classList.add('thb-hover');
        if (window.lazySizes?.loader) {
          window.lazySizes.loader.unveil(secondaryImage);
        }
      } else if (figure) {
        figure.classList.remove('thb-hover');
        if (secondaryImage) {
          secondaryImage.removeAttribute('srcset');
          secondaryImage.src = '';
        }
      }
    }

    setDefaultActiveSwatch({ preferPersisted = true } = {}) {
      if (!this.swatches) {
        return;
      }

      const swatchList = [...this.swatches.querySelectorAll('.product-card-swatch[data-href]')];
      if (!swatchList.length) {
        return;
      }
      
      if (!this.dataset.defaultSwatchHref) {
        const initialActive = swatchList.find((swatch) => swatch.classList.contains('active'));
        if (initialActive) {
          this.dataset.defaultSwatchHref = initialActive.getAttribute('data-href') || '';
        }
      }
      if (!this.dataset.selectedSwatchHref) {
        this.dataset.selectedSwatchHref = this.dataset.defaultSwatchHref || '';
      }
      const persistedHref = preferPersisted ? this.dataset.selectedSwatchHref || '' : '';
      const defaultHref = this.dataset.defaultSwatchHref || '';
      let activeSwatch =
        (persistedHref &&
          swatchList.find((swatch) => (swatch.getAttribute('data-href') || '') === persistedHref)) ||
        null;

      if (!activeSwatch && this.supportsInteractiveSwatches()) {
        const productUrl = this.querySelector('.product-featured-image-link')?.getAttribute('href') || '';
        const productPath = this.getSwatchPath(productUrl);
        const variantId = String(this.dataset.variantId || '');

        activeSwatch = swatchList.find((swatch) => {
          const href = swatch.getAttribute('data-href') || '';
          const hrefVariantId = this.getSwatchVariantId(href);

          if (variantId && hrefVariantId && hrefVariantId === variantId) {
            return true;
          }

          if (productPath && this.getSwatchPath(href) === productPath) {
            return true;
          }

          return href === productUrl;
        });
      }

      if (!activeSwatch) {
        activeSwatch =
          (defaultHref &&
            swatchList.find((swatch) => (swatch.getAttribute('data-href') || '') === defaultHref)) ||
          swatchList[0];
      }

      swatchList.forEach((swatch) => {
        swatch.classList.toggle('active', swatch === activeSwatch);
      });

      if (activeSwatch) {
        this.applySwatchSelection(activeSwatch, swatchList, { persist: false });
      }
    }

    enableQuickView() {
      this.quick_add.addEventListener('click', this.quickAdd.bind(this));
    }

    quickAdd(evt) {
      evt.preventDefault();
      if (this.quick_add.disabled) {
        return;
      }
      this.quick_add.classList.add('loading');
      this.quick_add.setAttribute('aria-disabled', true);

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          'Accept': 'application/javascript'
        }
      };

      let formData = new FormData(this.form);

      formData.append('id', this.quick_add.dataset.productId);
      formData.append('quantity', 1);
      formData.append('sections', this.getSectionsToRender().map((section) => section.section));
      formData.append('sections_url', window.location.pathname);

      config.body = formData;

      fetch(`${theme.routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            return;
          }
          this.renderContents(response);

          dispatchCustomEvent('cart:item-added', {
            product: response.hasOwnProperty('items') ? response.items[0] : response
          });
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          this.quick_add.classList.remove('loading');
          this.quick_add.removeAttribute('aria-disabled');
        });

      return false;
    }
    getSectionsToRender() {
      return [{
        id: 'Cart',
        section: 'main-cart',
        selector: '.thb-cart-form'
      },
      {
        id: 'Cart-Drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer'
      },
      {
        id: 'cart-drawer-toggle',
        section: 'cart-bubble',
        selector: '.thb-item-count'
      }];
    }
    renderContents(parsedState) {
      this.getSectionsToRender().forEach((section => {
        if (!document.getElementById(section.id)) {
          return;
        }
        const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
        if (typeof CartDrawer !== 'undefined') {
          new CartDrawer();
        }
        if (typeof Cart !== 'undefined') {
          new Cart().renderContents(parsedState);
        }
      }));


      if (document.getElementById('Cart-Drawer')) {
        document.body.classList.add('open-cc');
        document.getElementById('Cart-Drawer').classList.add('active');

        dispatchCustomEvent('cart-drawer:open');
      }

    }
    getSectionInnerHTML(html, selector = '.shopify-section') {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }
  }
  customElements.define('product-card', ProductCard);
}

/**
 *  @class
 *  @function PanelClose
 */
class PanelClose extends HTMLElement {

  constructor() {
    super();
    let cc = document.querySelector('.click-capture');

    // Add functionality to buttons
    this.addEventListener('click', (e) => this.close_panel(e));
    document.addEventListener('keyup', (e) => {
      if (e.code) {
        if (e.code.toUpperCase() === 'ESCAPE') {
          document.querySelectorAll('.side-panel').forEach((panel) => {
            panel.classList.remove('active');
            document.body.classList.remove('open-cc');
          });
        }
      }
    });
    cc.addEventListener('click', (e) => {
      document.body.classList.remove('open-cc');
      if (document.querySelector('.side-panel.active')) {
        document.querySelector('.side-panel.active').classList.remove('active');
      }
    });
  }

  close_panel(e) {
    e.preventDefault();
    let panel = e.target.closest('.side-panel');
    panel.classList.remove('active');
    document.body.classList.remove('open-cc');
  }
}
customElements.define('side-panel-close', PanelClose);

/**
 *  @class
 *  @function CartDrawer
 */
class CartDrawer {

  constructor() {
    this.container = document.getElementById('Cart-Drawer');

    if (!this.container) {
      return;
    }
    let button = document.getElementById('cart-drawer-toggle');

    if (!button) {
      return;
    }
    // Add functionality to buttons
    button.addEventListener('click', (e) => {
      e.preventDefault();
      document.body.classList.add('open-cc');
      this.container.classList.add('active');
      this.container.focus();
      dispatchCustomEvent('cart-drawer:open');
      this.initEvents();
    });

    this.debouncedOnChange = debounce((event) => {
      event.preventDefault();
      this.onChange(event);
    }, 300);

    document.addEventListener('cart:refresh', (event) => {
      event.preventDefault();
      this.refresh();
    });

    this.container.addEventListener('change', this.debouncedOnChange.bind(this));

    this.notesToggle();
    this.initEvents();
    // Terms checkbox
    this.termsCheckbox();
  }
  onChange(event) {
    if (event.target.classList.contains('qty')) {
      this.updateQuantity(event.target.dataset.index, event.target.value);
    }
    this.initEvents();
  }
  initEvents() {
    const that = this;
    let removes = this.container.querySelectorAll('.remove:not(.initialized)');
    removes?.forEach((remove) => {
      remove.addEventListener('click', (event) => {
        event.preventDefault();
        that.updateQuantity(event.target.dataset.index, '0');
      });
      remove.classList.add('initialized');
    });
  }
  getSectionsToRender() {
    return [{
      id: 'Cart-Drawer',
      section: 'cart-drawer',
      selector: '.cart-drawer'
    },
    {
      id: 'cart-drawer-toggle',
      section: 'cart-bubble',
      selector: '.thb-item-count'
    }];
  }
  getSectionInnerHTML(html, selector) {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }
  termsCheckbox() {
    let terms_checkbox = this.container.querySelector('#CartDrawerTerms'),
      checkout_button = this.container.querySelector('.button.checkout');

    if (terms_checkbox && checkout_button) {
      terms_checkbox.setCustomValidity(theme.strings.requiresTerms);
      checkout_button.addEventListener('click', function (e) {
        if (!terms_checkbox.checked) {
          terms_checkbox.reportValidity();
          terms_checkbox.focus();
          e.preventDefault();
        }
      });
    }
  }
  notesToggle() {
    let notes_toggle = document.getElementById('order-note-toggle');

    if (!notes_toggle) {
      return;
    }

    notes_toggle.addEventListener('click', (event) => {
      notes_toggle.nextElementSibling.classList.add('active');
    });
    notes_toggle.nextElementSibling.querySelectorAll('.button, .order-note-toggle__content-overlay').forEach((el) => {
      el.addEventListener('click', (event) => {
        notes_toggle.nextElementSibling.classList.remove('active');
        this.saveNotes();
      });
    });
  }
  saveNotes() {
    fetch(`${theme.routes.cart_update_url}.js`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      body: JSON.stringify({
        'note': document.getElementById('mini-cart__notes').value
      })
    });
  }
  updateQuantity(line, quantity) {
    this.container.querySelector(`#CartDrawerItem-${line}`).classList.add('thb-loading');
    const body = JSON.stringify({
      line,
      quantity,
      sections: this.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname
    });
    dispatchCustomEvent('line-item:change:start', {
      quantity: quantity
    });
    fetch(`${theme.routes.cart_change_url}`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': `application/json`
      },
      ...{
        body
      }
    })
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        const parsedState = state;
        const parsedSections = parsedState.sections || {};
        if(parsedState.errors){
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            setTimeout(async () => {
              document
                  .querySelectorAll(
                    ".form-cart-notification.error"
                  )
                  .forEach((element) => {
                    element.innerHTML = parsedState.errors;
                    element.style.display = "block";
                  });
            }, 2000);
        } else if (parsedState?.sections) {
            document
                  .querySelectorAll(
                    ".form-cart-notification.error"
                  )
                  .forEach((element) => {
                    element.innerHTML = '';
                    element.style.display = "none";
                  });
            this.getSectionsToRender().forEach((section => {
              const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
              const sectionName = section.section || '';
              if (sectionName && parsedSections && parsedSections[sectionName]) {
                elementToReplace.innerHTML = this.getSectionInnerHTML(parsedSections[sectionName], section.selector);
              }
            }));
            this.notesToggle();
            this.termsCheckbox();
    
            dispatchCustomEvent('line-item:change:end', {
              quantity: quantity,
              cart: parsedState
            });
            if (line && this.container && this.container.querySelector(`#CartDrawerItem-${line}`)?.length) {
              this.container.querySelector(`#CartDrawerItem-${line}`).classList.remove('thb-loading');
            }
            this.initEvents();
        }
      });
  }
  refresh() {
    let sections = 'cart-drawer,cart-bubble';
    fetch(`${window.location.pathname}?sections=${sections}`)
      .then((response) => {
        return response.json();
      })
      .then((state) => {
        const parsedState = state;
        if (!parsedState?.errors && parsedState?.sections) {
          this.getSectionsToRender().forEach((section => {
            const elementToReplace = document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
            if (section.section && parsedState[section.section]) {
              elementToReplace.innerHTML = this.getSectionInnerHTML(parsedState[section.section], section.selector);
            }
          }));
          this.notesToggle();
          this.termsCheckbox();
          this.initEvents();
        }
      });
  }
}

/**
 *  @class
 *  @function QuickView
 */
if (!customElements.get('quick-view')) {
  class QuickView extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.cc = document.querySelector('.click-capture');
      this.drawer = document.getElementById('Product-Drawer');
      this.body = document.body;

      this.addEventListener('click', this.setupEventListener.bind(this));
      this.cc.addEventListener('click', this.setupCCEventListener.bind(this));

    }
    setupCCEventListener(e) {
      this.body.classList.remove('open-cc');
      this.drawer.classList.remove('active');
      this.drawer.querySelector('#Product-Drawer-Content').innerHTML = '';
    }
    setupEventListener(e) {
      e.preventDefault();
      let productHandle = this.dataset.productHandle,
        href = `${theme.routes.root_url}/products/${productHandle}?view=quick-view`;

      // remove double `/` in case shop might have /en or language in URL
      href = href.replace('//', '/');
      if (!href || !productHandle) {
        return;
      }
      if (this.classList.contains('loading')) {
        return;
      }
      this.classList.add('loading');
      fetch(href, {
        method: 'GET'
      })
        .then((response) => {
          this.classList.remove('loading');
          return response.text();
        })
        .then(text => {
          const sectionInnerHTML = new DOMParser()
            .parseFromString(text, 'text/html')
            .querySelector('#Product-Drawer-Content').innerHTML;

          this.renderQuickview(sectionInnerHTML, href, productHandle);

        });
    }
    renderQuickview(sectionInnerHTML, href, productHandle) {
      if (sectionInnerHTML) {

        this.drawer.querySelector('#Product-Drawer-Content').innerHTML = sectionInnerHTML;

        let js_files = this.drawer.querySelector('#Product-Drawer-Content').querySelectorAll('script');

        if (js_files.length > 0) {
          var head = document.getElementsByTagName('head')[0];
          js_files.forEach((js_file, i) => {
            let script = document.createElement('script');
            script.src = js_file.src;
            head.appendChild(script);
          });
        }

        setTimeout(() => {
          window.dispatchEvent(new Event('resize'));
          if (Shopify && Shopify.PaymentButton) {
            Shopify.PaymentButton.init();
          }
          if (window.ProductModel) {
            window.ProductModel.loadShopifyXR();
          }
        }, 300);



        this.body.classList.add('open-cc');
        this.drawer.classList.add('active');
        this.drawer.querySelector('.side-panel-close').focus();

        dispatchCustomEvent('quick-view:open', {
          productUrl: href,
          productHandle: productHandle
        });
      }
    }
  }
  customElements.define('quick-view', QuickView);
}

/**
 *  @class
 *  @function ModalDialog
 */
class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener(
      'click',
      this.hide.bind(this)
    );
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target.nodeName === 'MODAL-DIALOG') this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    this.removeAttribute('open');
    this.querySelectorAll('.js-youtube').forEach((video) => {
      video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });
    this.querySelectorAll('.js-vimeo').forEach((video) => {
      video.contentWindow.postMessage('{"method":"pause"}', '*');
    });
    this.querySelectorAll('video').forEach((video) => video.pause());
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

/**
 *  @class
 *  @function ProductRecommendations
 */
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();

  }
  fetchProducts() {
    fetch(this.dataset.url)
      .then(response => response.text())
      .then(text => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;
          this.executeScripts();
          if (typeof window.hydrateNatoriRecommendations === 'function') {
            window.hydrateNatoriRecommendations(this);
          } else if (typeof window.hydrateNatoriRecommendationSwatches === 'function') {
            window.hydrateNatoriRecommendationSwatches();
          }
        }

        this.classList.add('product-recommendations--loaded');
      })
      .catch(e => {
        console.error(e);
      });
  }
  executeScripts() {
    const scripts = this.querySelectorAll('script');
    scripts.forEach(script => {
      const newScript = document.createElement('script');
      newScript.text = script.text;
      script.parentNode.replaceChild(newScript, script);
    });
  }
  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);

/**
 *  @class
 *  @function Localization
 */
class Localization {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".thb-localization-forms").forEach((localization) => {
      localization.addEventListener("change", (e) => {
        localization.querySelector('form').submit();
      });
    });
  }
}



/**
 *  @class
 *  @function SelectWidth
 */
class SelectWidth {
  constructor() {
    let _this = this;
    // resize on initial load
    document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);

    // delegated listener on change
    document.body.addEventListener("change", (e) => {
      if (e.target.matches(".resize-select") && e.target.offsetParent !== null) {
        _this.resizeSelect(e.target);
      }
    });
    window.addEventListener('resize.resize-select', function () {
      document.querySelectorAll(".resize-select").forEach(_this.resizeSelect);
    });
  }

  resizeSelect(sel) {
    let tempOption = document.createElement('option');
    tempOption.textContent = sel.selectedOptions[0].textContent;

    let tempSelect = document.createElement('select');
    tempSelect.style.visibility = "hidden";
    tempSelect.style.position = "fixed";
    tempSelect.appendChild(tempOption);

    sel.after(tempSelect);
    if (tempSelect.clientWidth > 0) {
      sel.style.width = `${+tempSelect.clientWidth + 12}px`;
    }
    tempSelect.remove();
  }
}

/**
 *  @class
 *  @function CollapsibleRow
 */
if (!customElements.get('collapsible-row')) {
  // https://css-tricks.com/how-to-animate-the-details-element/
  class CollapsibleRow extends HTMLElement {
    constructor() {
      super();

      this.details = this.querySelector('details');
      this.summary = this.querySelector('summary');
      this.content = this.querySelector('.collapsible__content');

      // Store the animation object (so we can cancel it if needed)
      this.animation = null;
      // Store if the element is closing
      this.isClosing = false;
      // Store if the element is expanding
      this.isExpanding = false;
    }
    connectedCallback() {
      this.setListeners();
    }
    setListeners() {
      this.querySelector('summary').addEventListener('click', (e) => this.onClick(e));
    }
    prepareAnimations() {
      let _this = this,
        summary_height = this.querySelector('summary').offsetHeight,
        content_height = this.querySelector('.collapsible__content').offsetHeight,
        initial_height = summary_height,
        final_height = summary_height + content_height;

      this.tl = false;
      this.tl = gsap.timeline({
        reversed: !_this.details.open,
        paused: true,
        inherit: false,
        ease: 'none',
        onStart: function () {
          _this.details.open = true;
          _this.details.style.overflow = 'hidden';
        },
        onReverseComplete: function () {
          _this.details.open = false;
          _this.details.style.overflow = '';
        }
      });

      this.tl
        .fromTo(_this.details, {
          height: function () {
            let h = Math.max(Math.max(initial_height, 0), 24);
            return h;
          },
          clearProps: 'height'
        }, {
          duration: 0.4,
          height: final_height,
          clearProps: 'height'
        });

      if (this.details.open) {
        this.tl.progress(1);
      }
    }
    instantClose() {
      this.tl.timeScale(10).reverse();
    }
    animateClose() {
      this.tl.timeScale(3).reverse();
    }
    animateOpen() {
      this.tl.timeScale(1).play();
    }
    onClick(e) {
      // Stop default behaviour from the browser
      e.preventDefault();
      // Add an overflow on the <details> to avoid content overflowing
      this.details.style.overflow = 'hidden';
      // Check if the element is being closed or is already closed
      if (this.isClosing || !this.details.open) {
        this.open();
        // Check if the element is being openned or is already open
      } else if (this.isExpanding || this.details.open) {
        this.shrink();
      }
    }
    shrink() {
      // Set the element as "being closed"
      this.isClosing = true;

      // Store the current height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the height of the summary
      const endHeight = `${this.summary.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 250,
        easing: 'ease'
      });

      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(false);
      // If the animation is cancelled, isClosing variable is set to false
      this.animation.oncancel = () => this.isClosing = false;
    }

    open() {
      // Apply a fixed height on the element
      this.details.style.height = `${this.details.offsetHeight}px`;
      // Force the [open] attribute on the details element
      this.details.open = true;
      // Wait for the next frame to call the expand function
      window.requestAnimationFrame(() => this.expand());
    }

    expand() {
      // Set the element as "being expanding"
      this.isExpanding = true;
      // Get the current fixed height of the element
      const startHeight = `${this.details.offsetHeight}px`;
      // Calculate the open height of the element (summary height + content height)
      const endHeight = `${this.summary.offsetHeight + this.content.offsetHeight}px`;

      // If there is already an animation running
      if (this.animation) {
        // Cancel the current animation
        this.animation.cancel();
      }

      // Start a WAAPI animation
      this.animation = this.details.animate({
        // Set the keyframes from the startHeight to endHeight
        height: [startHeight, endHeight]
      }, {
        duration: 400,
        easing: 'ease-out'
      });
      // When the animation is complete, call onAnimationFinish()
      this.animation.onfinish = () => this.onAnimationFinish(true);
      // If the animation is cancelled, isExpanding variable is set to false
      this.animation.oncancel = () => this.isExpanding = false;
    }

    onAnimationFinish(open) {
      // Set the open attribute based on the parameter
      this.details.open = open;
      // Clear the stored animation
      this.animation = null;
      // Reset isClosing & isExpanding
      this.isClosing = false;
      this.isExpanding = false;
      // Remove the overflow hidden and the fixed height
      this.details.style.height = this.details.style.overflow = '';
    }
  }
  customElements.define('collapsible-row', CollapsibleRow);
}

if (typeof SelectWidth !== 'undefined') {
  new SelectWidth();
}
document.addEventListener('DOMContentLoaded', () => {

  if (typeof Localization !== 'undefined') {
    new Localization();
  }
  if (typeof CartDrawer !== 'undefined') {
    const cartDrawer = new CartDrawer();
    window.cartDrawer = cartDrawer;
  }

});
